import styled from 'styled-components';

import { mediaConfined, zIndexStickyLayer3 } from '@xing-com/layout-tokens';
import {
  space4XL,
  spaceS,
  spaceXL,
  spaceXS,
  spaceXXL,
  xdlColorBackground,
} from '@xing-com/tokens';

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  gap: ${spaceXL};

  @media ${mediaConfined} {
    gap: ${spaceXXL};
  }
`;

export const HeaderContainer = styled.div`
  padding: ${space4XL} ${spaceXS} ${spaceS};
  position: sticky;
  top: 0px;
  background: ${xdlColorBackground};
  z-index: ${zIndexStickyLayer3}; // let the step content scroll below but keep the modal X button above

  &:focus {
    outline: none;
  }
`;

export const StepContainer = styled.div`
  flex-grow: 1;
  padding: 0 ${spaceXS};

  @media ${mediaConfined} {
    flex-grow: 0;
  }
`;
